import React, { useContext, useEffect, useState } from "react";
import "./AllSlotGamesStyle.scss";
import { allSlotGamesTextContent } from "./constant/index";
import GameCard from "../Common_UI_Kit/GameCard";
import { useNavigate } from "react-router-dom";
import GamesFilter from "../GamesFilterSection";
import SearchWidget from "../Common_UI_Kit/SearchWidget";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { getSlotGames } from "network/game.services";
import { convertToCamelCase } from "util.js";
import { GameContext } from "context/context";
import { debounce } from "lodash";

const { allSlotGamesContent, gamesFilterContent } = allSlotGamesTextContent;
const AllSlotGamesSection = () => {
  const [slotGames, setSlotGames] = useState([])
  
  const [gameFilter, setGameFilter] = useState(gamesFilterContent)
  const [pageNo, setPageNo] = useState(1)

  const { gameCategories } = useContext(GameContext)

  useEffect(() => {
    function handleCallback (data) {
      setSlotGames(data)
    }

    const params = {
      page: pageNo,
      perPage: 12
    }
    getSlotGames(handleCallback, params)
  }, [])

  useEffect(() => {
    if (gameCategories) {
      const newFilters = Object.keys(gameCategories).map(categoryName => ({filterNavText: categoryName }))
      setGameFilter([...gamesFilterContent, ...newFilters])
    }
  }, [gameCategories])

  const [activeIndex, setActiveIndex] = useState(0);

  const navigate = useNavigate();

  const handleCardClick = (game) => {
    navigate(`/slot-game-info`, { state: game });
  };

  const handleLoadMorePage = () => {
    setPageNo(prev => prev + 1)

    function handleCallback (data) {
      setSlotGames(prev => ([...prev, ...data]))
    }

    const params = {
      page: pageNo + 1,
      perPage: 12,
      subCategory: gamesFilterContent?.includes(gameFilter[activeIndex]) ? '' :gameFilter[activeIndex]?.filterNavText

    }
    getSlotGames(handleCallback, params)
  }

  const handleFilterChange = (index) => {
    setActiveIndex(index)

    setPageNo(1)

    function handleCallback (data) {
      setSlotGames(data)
    }

    const params = {
      page: 1,
      perPage: 12,
      subCategory: gamesFilterContent?.includes(gameFilter[index]) ? '' :gameFilter[index]?.filterNavText
    }
    getSlotGames(handleCallback, params)
  }

  const handleSearchFilterChange = debounce((e) => {
    setPageNo(1)

    function handleCallback (data) {
      setSlotGames(data)
    }

    const params = {
      page: 1,
      perPage: 10,
      subCategory: gamesFilterContent?.includes(gameFilter[activeIndex]) ? '' :gameFilter[activeIndex]?.filterNavText,
      searchQuery: e.target.value
    }
    getSlotGames(handleCallback, params)
  }, 800)

  return (
    <section className="slot-games-section">
      <div className="slot-games-wrap">
        <div className="filters-grid-box">
          <GamesFilter
            filtersText={gameFilter}
            activeIndex={activeIndex}
            setActiveIndex={handleFilterChange}
          />
          <SearchWidget handleSearchFilterChange={handleSearchFilterChange} />
        </div>

        <div className="slot-games-box">
          <div className="games-grid-box">
            {slotGames?.filter(game => game.isActive)?.map((game, index) => {
              const imgName = convertToCamelCase(game.name)
              const img = `/assets/images/slot/thumbnail/${imgName}.png`
              console.log('imgName', imgName, game.name)
              return (
                <>
                  <GameCard
                    key={game?.id}
                    gameNameText={game.name}
                    gameImageSrc={img}
                    onClick={() => handleCardClick(game)}
                    gameId={game?.id}
                  />

                </>
              )
            })}
          </div>

          <div className="btn-box">
            <CustomButton buttonType="secondary" label={allSlotGamesTextContent.btnText} onClick={handleLoadMorePage} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllSlotGamesSection;
